// src/components/store/sections/faqs/FaqV95BubbleqaEmeraldMint.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV95BubbleqaEmeraldMint(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={95}
      archKey="bubble_qa"
      archLabel="Chat Bubble Q&A"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      hexCol="#10b981"
      {...props}
    />
  );
}
